import { j as e } from "./jsx-runtime.DGlMoOmv.js";
import { useFormContext as D } from "react-hook-form";
import { d as S, e as N, f as z, b as E, g as R } from "./Form.LdCd9gH2.js";
import { V as k } from "./index.BkBvp-m6.js";
import * as c from "react";
import { A as O, b as Z, a as H } from "./Avatar.DWv-3vyX.js";
import { B as L } from "./Button.Ccj-dDdM.js";
import { S as W } from "./Spinner.Brgz0Lk4.js";
import { u as _, C as B } from "./useCloudinaryUploadWidget.BIXIyVyy.js";
import { D as T, d as Q, j as V, b as I, c as q } from "./Dialog.CH2ZNDp8.js";
import { u as G } from "./use-media-query.CzJ6WnFm.js";
import { c as J } from "./index.CxSWpsOB.js";
const K = (t, r) => /* @__PURE__ */ e.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: r, ...t, children: [
  /* @__PURE__ */ e.jsx("path", { fill: "currentColor", d: "M6.5 10.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm3.5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" }),
  /* @__PURE__ */ e.jsx("path", { fill: "currentColor", d: "M8.5 3c-.55 0-1.07.26-1.4.7L6.125 5H3.75A1.75 1.75 0 0 0 2 6.75v8.5c0 .966.784 1.75 1.75 1.75h12.5A1.75 1.75 0 0 0 18 15.25v-8.5A1.75 1.75 0 0 0 16.25 5h-2.375L12.9 3.7c-.33-.44-.85-.7-1.4-.7h-3Zm-.2 1.6a.25.25 0 0 1 .2-.1h3a.25.25 0 0 1 .2.1l1.425 1.9h3.125a.25.25 0 0 1 .25.25v8.5a.25.25 0 0 1-.25.25H3.75a.25.25 0 0 1-.25-.25v-8.5a.25.25 0 0 1 .25-.25h3.125L8.3 4.6Z" }),
  /* @__PURE__ */ e.jsx("path", { fill: "currentColor", d: "M2.25 3.75A.75.75 0 0 1 3 3h2a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z" })
] }), X = c.forwardRef(K), Y = ({
  avatarProps: t,
  className: r,
  contentClassName: d,
  defaultAvatarUrl: p,
  dialogProps: m,
  disabled: l,
  intl: s,
  overlayClassName: i,
  showUploadButton: o = !0,
  testId: f = "avatar-upload",
  onUploadError: g,
  onUploadSuccess: w
}) => {
  const [j, n] = c.useState(!1), [v, C] = c.useState(null), [u, A] = c.useState(p || ""), y = G("(max-width: 576px)", {
    isActive: !0
  }), b = t?.size ?? (y ? 96 : 120), x = (a) => {
    a.preventDefault(), n(!0);
  }, M = (a) => {
    g?.(a), n(!1);
  }, F = (a) => {
    A(a.secure_url?.replace("upload/", "upload/c_crop,g_custom/")), w?.(a), n(!1);
  }, {
    cloudinary: h,
    uploadWidget: U
  } = _({
    onError: M,
    onSuccess: F,
    widgetContainerRef: v,
    uploaderType: B.Avatar,
    intl: s
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: J(o && "tw-pb-[24px]", r), "data-testid": f, children: /* @__PURE__ */ e.jsxs("div", { className: "tw-relative tw-flex tw-items-center tw-flex-col", children: [
      /* @__PURE__ */ e.jsx(
        "button",
        {
          disabled: !h || l,
          onClick: x,
          type: "button",
          children: /* @__PURE__ */ e.jsxs(O, { size: b, ...t, children: [
            /* @__PURE__ */ e.jsx(Z, { src: u }),
            /* @__PURE__ */ e.jsx(H, {})
          ] })
        }
      ),
      o && /* @__PURE__ */ e.jsx(L, { appearance: "white", disabled: !h || l, prefix: /* @__PURE__ */ e.jsx(X, {}), onClick: x, shape: "pill", className: "tw-absolute tw-bottom-[-16px]", children: u ? s.formatMessage({
        id: "wEQDC6",
        defaultMessage: [{
          type: 0,
          value: "Edit"
        }]
      }) : s.formatMessage({
        id: "2/2yg+",
        defaultMessage: [{
          type: 0,
          value: "Add"
        }]
      }) })
    ] }) }),
    /* @__PURE__ */ e.jsx(T, { ...m, open: j, onOpenChange: n, children: /* @__PURE__ */ e.jsxs(Q, { size: "lg", className: d, overlayClassName: i, children: [
      /* @__PURE__ */ e.jsx(k, { asChild: !0, children: /* @__PURE__ */ e.jsx(V, { children: s.formatMessage({
        id: "Oz0em5",
        defaultMessage: [{
          type: 0,
          value: "Upload a profile photo"
        }]
      }) }) }),
      /* @__PURE__ */ e.jsxs(I, { className: "tw-px-0 sm:tw-px-0 tw-relative", children: [
        /* @__PURE__ */ e.jsx("span", { className: "tw-absolute tw-top-0 tw-right-0 tw-mx-16 tw-h-[50px] tw-flex tw-items-center", children: /* @__PURE__ */ e.jsx(q, {}) }),
        /* @__PURE__ */ e.jsx("div", { id: "cloudinary-widget-container", ref: (a) => C(a), children: !U && /* @__PURE__ */ e.jsx("div", { className: "tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center", children: /* @__PURE__ */ e.jsx(W, { size: "large", appearance: "black" }) }) })
      ] })
    ] }) })
  ] });
}, ce = ({
  name: t,
  label: r,
  subcopy: d,
  note: p,
  className: m,
  ...l
}) => {
  const {
    control: s
  } = D();
  return /* @__PURE__ */ e.jsx(S, { control: s, name: t, render: ({
    field: i
  }) => /* @__PURE__ */ e.jsxs(N, { className: m, children: [
    !!r && /* @__PURE__ */ e.jsx(z, { subcopy: d, children: r }),
    /* @__PURE__ */ e.jsx(E, { children: /* @__PURE__ */ e.jsx(Y, { ...l, defaultAvatarUrl: i.value, onUploadSuccess: (o) => {
      i.onChange(o.secure_url);
    }, onUploadError: (o) => {
      s.setError(t, {
        type: "manual",
        message: o
      });
    } }) }),
    /* @__PURE__ */ e.jsx(R, { children: p })
  ] }) });
};
export {
  Y as A,
  ce as a
};
//# sourceMappingURL=AvatarUploadField.Bma03mNA.js.map
